module.exports = __webpack_public_path__ + "img/242.5d9fb466.png";